import { getContrastColor } from '@/utils/functions/getContrastColor';
import { Tag, TagProps } from 'antd';
import { forwardRef } from 'react';

interface Props extends TagProps {
  color: string;
  label: string;
}

const WorkOrderStatusTag = forwardRef<HTMLDivElement, Props>(
  ({ color, label, ...props }, ref) => {
    return (
      <Tag
        ref={ref}
        color={color}
        {...props}
        style={{
          ...props.style,
          color: getContrastColor(color),
          fontWeight: 600,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          wordBreak: 'break-all',
          borderRadius: 4,
        }}
      >
        {label}
      </Tag>
    );
  },
);

WorkOrderStatusTag.displayName = 'WorkOrderStatusTag';

export default WorkOrderStatusTag;
